import React, { useState } from "react";
import i18next from "i18next";
import PropTypes from "prop-types";
import { AlertTriangle, ChevronDown, Check } from "react-feather";

const DropdownSelect = ({
    options,
    translationKey,
    placeholder,
    label,
    value,
    bindName,
    onChange,
    error,
    errorMessage,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectValue = (option) => {
        onChange(option);
        setIsOpen(false);
    };

    const displayValue = () => {
        if (value) {
            return i18next.t(`${translationKey}.${value}`);
        }
        return "";
    };

    return (
        <div className="pottsalat-form__row dropdown-select">
            <label className="pottsalat-form__label">{label}</label>
            <div className="pottsalat-form__input-wrapper dropdown-select__selected-container">
                <input
                    className={`pottsalat-form__text-${
                        error ? "error" : "input"
                    } dropdown-select__selected`}
                    onFocus={() => setIsOpen(true)}
                    name={bindName}
                    value={displayValue()}
                    placeholder={placeholder}
                    readOnly
                />
                <ChevronDown size={24} className="" />
            </div>
            {error && (
                <span className="pottsalat-form__error-msg">
                    <AlertTriangle />
                    {errorMessage}
                </span>
            )}
            <div
                className={`dropdown-select__options ${
                    isOpen ? "open" : "closed"
                }`}
            >
                {options.map((option) => (
                    <div
                        className="dropdown-select__options__option"
                        key={option}
                        onClick={() => selectValue(option)}
                    >
                        <span>{i18next.t(`${translationKey}.${option}`)}</span>
                        {value === option && <Check />}
                    </div>
                ))}
            </div>
        </div>
    );
};

DropdownSelect.propTypes = {
    options: PropTypes.arrayOf(PropTypes.string),
    translationKey: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    bindName: PropTypes.string,
    onChange: PropTypes.func,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    disabled: PropTypes.bool,
};

export default DropdownSelect;
